<div class="schede-container">
  <!-- Header della pagina -->
  <div class="schede-header">
    <div class="title-container">
      <span class="material-icons" style="vertical-align: middle; margin-right: 8px; font-size: 28px; color: #166F72;">map</span>
      <h1 class="page-title">{{ titoloSchede }}</h1>
      <!-- Statistiche schede senza geometria - solo per UMVS/ADMIN/SUPERADMIN, NON per Ente Esecutore -->
      <div *ngIf="isUmvsOrAdmin && !isEnteEsecutore && numeroSchedeSenzaGeometria > 0"
           class="geometria-stats-badge"
           pTooltip="NUMERO DI SCHEDE PRIVE DI GEOMETRIA"
           tooltipPosition="bottom">
        <i class="pi pi-exclamation-triangle"></i>
        <span class="geometria-stats-number-compact">{{ numeroSchedeSenzaGeometria }}</span>
      </div>
    </div>

    <div class="actions-container">
      <!-- Area Ricerca e Filtri Inline - TUTTO SULLA STESSA RIGA -->
      <div class="search-and-filters-container">
        <!-- Campo di ricerca -->
        <div class="custom-search-input">
          <i class="pi pi-search search-icon" [ngClass]="{'hidden': filtroTestoGlobale.length > 0}"></i>
          <input
            type="text"
            pInputText
            [(ngModel)]="filtroTestoGlobale"
            (input)="onFiltroGlobaleChange($event)"
            placeholder="Cerca schede..."
            class="search-input"
            [ngClass]="{'has-text': filtroTestoGlobale.length > 0}"
          />
          <i class="pi pi-times clear-icon" *ngIf="filtroTestoGlobale.length > 0" (click)="pulisciFiltroGlobale()" style="cursor: pointer;"></i>
        </div>

        <!-- Filtri Inline -->
        <div class="inline-filters" *ngIf="!isEnteEsecutore">
          <!-- Filtro Bacino -->
          <div class="filter-item bacino-filter">
            <label class="filter-label">
              <i class="pi pi-globe filter-icon"></i>
              Bacino
            </label>
            <p-dropdown
              [options]="bacini"
              [(ngModel)]="filtri.bacino"
              optionLabel="denominazione"
              [showClear]="false"
              placeholder="Bacino"
              styleClass="compact-dropdown bacino-dropdown"
              appendTo="body"
              (onChange)="applicaFiltri()">
              <ng-template let-bacino pTemplate="item">
                <div class="bacino-filtro-badge">
                   <span class="bacino-filtro-value">{{ bacino.denominazione | uppercase }}</span>
                </div>
              </ng-template>
              <ng-template let-bacino pTemplate="selectedItem">
                <div class="bacino-filtro-badge">
                   <span class="bacino-filtro-value">{{ bacino.denominazione | uppercase }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>

          <!-- Filtro Comune -->
          <div class="filter-item comune-filter">
            <label class="filter-label">
              <i class="pi pi-map-marker filter-icon"></i>
              Comune
            </label>
            <p-dropdown
              [options]="comuni"
              [(ngModel)]="filtri.comune"
              optionLabel="denominazione"
              [showClear]="false"
              placeholder="Comune"
              styleClass="compact-dropdown comune-dropdown"
              appendTo="body"
              (onChange)="applicaFiltri()">
              <ng-template let-comune pTemplate="item">
                <div class="comune-filtro-badge">
                   <span class="code-value">{{ comune.denominazione | uppercase }}</span>
                </div>
              </ng-template>
              <ng-template let-comune pTemplate="selectedItem">
                <div class="comune-filtro-badge">
                   <span class="code-value">{{ comune.denominazione | uppercase }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>

          <!-- Filtro Geometria - solo per UMVS o ADMIN -->
          <div *ngIf="isUmvsOrAdmin" class="filter-item geometria-filter">
            <label class="filter-label">
              <i class="pi pi-map filter-icon"></i>
              Geometria
            </label>
            <p-dropdown
              [options]="opzioniFiltroGeometria"
              [(ngModel)]="filtroGeometria"
              optionLabel="label"
              optionValue="value"
              [showClear]="false"
              placeholder="Tutte"
              styleClass="compact-dropdown geometria-dropdown"
              appendTo="body"
              (onChange)="onFiltroGeometriaChange()">
              <ng-template let-opzione pTemplate="item">
                <div style="font-size: 0.875rem;">
                  {{ opzione.label }}
                </div>
              </ng-template>
              <ng-template let-opzione pTemplate="selectedItem">
                <span style="font-size: 0.875rem;">
                  {{ opzione?.label || 'Tutte' }}
                </span>
              </ng-template>
            </p-dropdown>
          </div>

          <!-- Reset Filtri -->
          <button
            *ngIf="filtriAttivi"
            pButton type="button"
            icon="pi pi-filter-slash"
            class="p-button-rounded p-button-text p-button-danger reset-filters-btn"
            (click)="azzeraTuttiFiltri()"
            pTooltip="Rimuovi tutti i filtri"
            tooltipPosition="top">
          </button>
        </div>
      </div>

      <!-- Container per i pulsanti di azione -->
      <div class="action-buttons-container">
        <button [disabled]="!schedeCaricate" *ngIf="!isEnteEsecutore" class="action-button" (click)="nuovaScheda()"
        pTooltip="Nuova scheda" tooltipPosition="top"
        style="background-color: #AAE79D; color: #333; border: 1px solid #8CC97D; box-shadow: 0 2px 4px rgba(0,0,0,0.1); border-radius: 6px; cursor: pointer;">
          <span class="material-icons">add_circle</span>
        </button>
        <button [disabled]="!schedeCaricate" *ngIf="isEnteEsecutore" class="action-button" (click)="nuovaScheda()"
          pTooltip="Nuova scheda" tooltipPosition="top"
          style="background-color: #8ecbb9; color: #333; border: 1px solid #8CC97D; box-shadow: 0 2px 4px rgba(0,0,0,0.1); border-radius: 6px; cursor: pointer;">
          <span class="material-icons" style="margin-right: 6px; font-size: 16px;">add_circle</span>
        </button>
        <button [disabled]="!schedeCaricate" class="action-button" (click)="scaricaReportSchede()"
          pTooltip="Scarica report delle schede" tooltipPosition="top"
          style="background-color: #C7CEEA; color: #333; border: 1px solid #B2BCDC; box-shadow: 0 2px 4px rgba(0,0,0,0.1); border-radius: 6px;">
          <span class="material-icons">download</span>
        </button>
        <button [disabled]="!schedeCaricate" class="action-button" (click)="caricaSchede()"
        pTooltip="Ricarica schede" tooltipPosition="top"
          style="background-color: #F8E9A1; color: #333; border: 1px solid #EBDC8D; box-shadow: 0 2px 4px rgba(0,0,0,0.1); border-radius: 6px;">
          <span class="material-icons">refresh</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Contenuto principale -->
  <div class="schede-content">
    <!-- TabView per ente esecutore o admin/umvs -->
    <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)" styleClass="schede-tabs">
    <!-- Tab Schede -->
    <p-tabPanel header="Lista" leftIcon="pi pi-table">
      <!-- Loader mentre vengono caricate le schede -->
      <div *ngIf="!schedeCaricate" class="loading-container">
        <div class="spinner"></div>
        <p>Caricamento schede in corso...</p>
      </div>

      <!-- Lista delle schede con p-table -->
      <div *ngIf="schede.length > 0" class="schede-list">
          <!-- Messaggio se non ci sono richieste -->
          <div *ngIf="schede.length === 0" class="empty-state">
            <span class="material-icons">search_off</span>
            <h3>Nessuna scheda trovata</h3>
          </div>



          <!-- PrimeNG Table -->
          <p-table
            *ngIf="schedeCaricate && schede.length > 0"
            #dt
            [value]="schede"
            [columns]="cols"
            [paginator]="true"
            [rows]="10"
            [rowsPerPageOptions]="[10,50,100,200]"
            styleClass="p-datatable-sm p-datatable-gridlines"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Schede da {first} a {last} di {totalRecords}"
            [globalFilterFields]="['codice', 'statoApprovazione', 'vecchioCodiceUmvs', 'oggettoIntervento', 'comune.denominazione', 'bacino.denominazione', 'accessibilita', 'frequenza']"
            [sortField]="'codice'" [sortOrder]="1"
            responsiveLayout="stack"
            [rowHover]="true"
            [loading]="!schedeCaricate"
            [style]="{'margin-bottom': '20px'}"
            (onFilter)="onFilterChange($event)">

            <!-- Intestazioni delle colonne -->
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 2%; text-align: center; font-size: 12px;">Azioni</th>
                <th *ngFor="let col of cols"
                  [pSortableColumn]="col.sortable ? col.field : null"
                  [style.width]="col.width"
                  [ngStyle]="{
                      'text-align': col.field === 'codice'
                      || col.field === 'vecchioCodice'
                      || col.field === 'codice Tipologia Intervento'
                      || col.field === 'codice ATO'
                      || col.field === 'statoApprovazione'
                      || col.field === 'bacino'
                      || col.field === 'comune'
                      || col.field === 'oggettoIntervento'
                      || col.field === 'accessibilita'
                      || col.field === 'frequenza'
                      || col.field === 'importoUltimoIntervento'
                      || col.field === 'annoUltimoIntervento'
                      || col.field === 'annoProssimoIntervento'
                      || col.field === 'allegati'
                      || col.field === 'geometriaCaricata'
                      ? 'center' : 'left',
                      'font-size': '12px'
                      }">
                  {{ col.header }}
                  <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
                </th>
              </tr>
            </ng-template>

            <!-- Corpo della tabella -->
            <ng-template pTemplate="body" let-scheda>
              <tr>
                <td class="text-center" style="width: 10px;">
                  <button
                    pButton type="button" style="color:rgb(39, 128, 15)"
                    icon="pi pi-ellipsis-v" class="p-button-rounded p-button-text small-icon"
                    (click)="openCaricaAzioni($event,scheda)"
                    >
                  </button>
                </td>
                <td>
                  <div *ngIf="scheda.statoApprovazione.descrizione.toUpperCase() === 'IN ATTESA'"
                  class="code-badge-in-attesa"
                  pTooltip="In attesa di approvazione"
                  tooltipPosition="top"
                  >
                    <span class="code-value-in-attesa">{{ scheda.codice }}</span>
                  </div>
                  <div *ngIf="scheda.statoApprovazione.descrizione.toUpperCase() !== 'IN ATTESA'" class="code-badge">
                    <span class="code-value">{{ scheda.codice }}</span>
                  </div>
                </td>
                <td>
                  <div *ngIf="scheda.vecchioCodiceUmvs" class="old-code-badge">
                    <!-- <span class="material-icons code-prefix">memory</span> -->
                    <span class="old-code-value">{{ scheda.vecchioCodiceUmvs }}</span>
                  </div>
                </td>
                <td>
                  <div class="bacino-badge">
                    <!-- <span class="material-icons code-prefix">memory</span> -->
                    <span class="code-value">{{ scheda.bacino.denominazione | uppercase }}</span>
                  </div>
                </td>
                <td>
                  <div class="comune-badge">
                    <!-- <span class="material-icons code-prefix">memory</span> -->
                    <span class="code-value">{{ scheda.comune.denominazione | uppercase }}</span>
                  </div>
                </td>
              <!--   <td class="text-center">
                  <span style="display: block; text-align: left; " class="titolo-scheda-badge"
                  pTooltip="{{ scheda.note }}" tooltipPosition="top"> {{ scheda.titolo }}</span>

                </td> -->
                <td>
                  <span *ngIf="scheda.oggettoIntervento " style="display: block; text-align: center; font-size: 11.5px;"
                  [ngStyle]="{
                    'background-color': stiliService.getColoreOggettoIntervento(scheda.oggettoIntervento),
                    'color': '#000000',
                    'padding': '4px 8px',
                    'border-radius': '4px',
                    'font-weight': 'bold',
                    'display': 'block',
                    'text-align': 'center',
                    'width': 'fit-content',
                    'margin': '0 auto'
                  }"
                  pTooltip="{{ scheda.oggettoIntervento.descrizione }}" tooltipPosition="top">
                    {{ scheda.oggettoIntervento.codice }}
                  </span>
                </td>



                <td>
                  <span *ngIf="scheda.codiceAto && scheda.codiceAto.codice!='-'" style="display: block; text-align: center; font-size: 11.5px;"
                  [ngStyle]="{
                    'background-color': stiliService.getColoreCodiceAto(scheda.codiceAto?.codice || scheda.codiceAto?.codice || ''),
                    'color': '#000000',
                    'padding': '4px 8px',
                    'border-radius': '4px',
                    'font-weight': 'bold',
                    'display': 'block',
                    'text-align': 'center',
                    'width': 'fit-content',
                    'margin': '0 auto'
                  }"
                  >
                    {{ scheda.codiceAto.codice }}
                  </span>
                </td>
                <td>
                  <span *ngIf="scheda.nuovoCodiceAto && scheda.nuovoCodiceAto.codice!='-'" style="display: block; text-align: center; font-size: 11.5px;"
                  [ngStyle]="{
                    'background-color': stiliService.getColoreCodiceAto(scheda.nuovoCodiceAto?.codice || scheda.nuovoCodiceAto?.codice || ''),
                    'color': '#000000',
                    'padding': '4px 8px',
                    'border-radius': '4px',
                    'font-weight': 'bold',
                    'display': 'block',
                    'text-align': 'center',
                    'width': 'fit-content',
                    'margin': '0 auto'
                  }"
                  >
                    {{ scheda.nuovoCodiceAto.codice }}
                  </span>
                </td>
                <td>
                  <div *ngIf="scheda.accessibilita"
                       [ngStyle]="stiliService.getStileAccessibilita(scheda.accessibilita.id)"
                       pTooltip="{{ scheda.accessibilita.descrizione }}" tooltipPosition="top">
                    <span *ngIf="scheda.accessibilita.id !== 2 && scheda.accessibilita.id !== 3" [class]="stiliService.getClasseIconaAccessibilita(scheda.accessibilita.id)" >
                      {{ stiliService.getIconaAccessibilita(scheda.accessibilita.id) }}
                    </span>
                    <!--  -->
                    <img [ngStyle]="stiliService.getStileAccessibilitaSpeciale(scheda.accessibilita.id)" *ngIf="scheda.accessibilita.id === 2" src="assets/icons/car-suv.svg"   alt="car-suv" >
                    <img [ngStyle]="stiliService.getStileAccessibilitaSpeciale(scheda.accessibilita.id)" *ngIf="scheda.accessibilita.id === 3" src="assets/icons/car-crane.svg" alt="car-crane" >
                  </div>
                </td>
                <td>
                  <span *ngIf="scheda.frequenza" class="badge"
                      [ngStyle]="{
                        'background-color': stiliService.getColoreFrequenzaIntervento(scheda.frequenza),
                        'color': '#000000',
                        'padding': '4px 8px',
                        'border-radius': '4px',
                        'font-size': '12px',
                        'display': 'block',
                        'text-align': 'center',
                        'width': 'fit-content',
                        'margin': '0 auto'
                      }">
                    {{ scheda.frequenza }}
                  </span>
                </td>
                <td>
                  <span *ngIf="scheda.annoUltimoIntervento" class="badge"
                      [ngStyle]="{
                        'background-color': stiliService.getColoreAnnoIntervento(scheda.annoUltimoIntervento),
                        'color': '#ffffff',
                        'padding': '4px 8px',
                        'border-radius': '4px',
                        'font-size': '12px',
                        'display': 'block',
                        'text-align': 'center',
                        'width': 'fit-content',
                        'margin': '0 auto'
                      }">
                  {{ scheda.annoUltimoIntervento }}
                  </span>
                </td>
                <td>
                  <span *ngIf="scheda.annoProssimoIntervento" class="badge"
                  [ngStyle]="{
                    'background-color': stiliService.getColoreAnnoIntervento(scheda.annoProssimoIntervento),
                    'color': '#ffffff',
                    'padding': '4px 8px',
                    'border-radius': '4px',
                    'font-size': '12px',
                    'display': 'block',
                    'text-align': 'center',
                    'width': 'fit-content',
                    'margin': '0 auto'
                  }"> {{ scheda.annoProssimoIntervento }}</span>
                </td>
                <td class="text-center">
                  <div *ngIf="scheda.importoUltimoIntervento" class="custom-chip" style="display: flex; margin: 0 auto; width: fit-content; background-color: #3c6a76; border: 1px solid #1d7572;">
                    <span class="chip-label" style="font-size: 12px; color: #ffffff;">{{ scheda.importoUltimoIntervento ? (scheda.importoUltimoIntervento | currency:'EUR':'':'1.2-2':'it-IT') : '-' }}</span>
                    <i class="pi pi-euro" style="font-size: 13px; color: #fffffe; margin-left: 6px;"></i>
                  </div>
                </td>
                <td style="width: 25px; text-align: center; padding: 0.15rem;">
                  <div class="download-actions" style="display: flex; justify-content: center;">
                    <button *ngIf="scheda.pdfCaricato && scheda.percorsoPdf" pButton type="button"
                      icon="pi pi-file-pdf"
                      class="p-button-rounded p-button-text p-button-sm"
                      style="font-size: 0.75rem; color: #7d9f25; margin: 0; padding: 0.15rem; min-width: unset; width: 1.5rem; height: 1.5rem;"
                      (click)="scaricaAllegati(scheda, 'pdf')"
                      pTooltip="Scarica PDF" tooltipPosition="left">
                    </button>
                    <button *ngIf="scheda.xlsCaricato && scheda.percorsoXls" pButton type="button"
                      icon="pi pi-file-excel"
                      class="p-button-rounded p-button-text p-button-sm"
                      style="font-size: 0.75rem; color: #103b46; margin: 0; padding: 0.15rem; min-width: unset; width: 1.5rem; height: 1.5rem;"
                      (click)="scaricaAllegati(scheda, 'xls')"
                      pTooltip="Scarica Excel" tooltipPosition="left">
                    </button>
                  </div>
                </td>
                <!-- Colonna Geometria Caricata - solo per UMVS o ADMIN -->
                <td *ngIf="isUmvsOrAdmin" class="text-center" style="width: 2%; padding: 0.5rem;">
                  <i *ngIf="scheda.geometriaCaricata"
                     class="pi pi-map-marker"
                     style="font-size: 1rem; color: #22c55e; cursor: pointer;"
                     pTooltip="Geometria caricata - Clicca per mostrare sulla mappa"
                     tooltipPosition="top"
                     (click)="mostraSchedaSuMappa(scheda)">
                  </i>
                  <i *ngIf="!scheda.geometriaCaricata"
                     class="pi pi-map-marker"
                     style="font-size: 1rem; color: #94a3b8; opacity: 0.4;"
                     pTooltip="Geometria non caricata"
                     tooltipPosition="top">
                  </i>
                </td>

              </tr>
            </ng-template>

            <!-- Footer della tabella -->
            <ng-template pTemplate="paginatorleft">
              <!-- Bottone di refresh spostato in alto -->
            </ng-template>

            <ng-template pTemplate="paginatorright">
              <!-- Bottoni aggiuntivi se necessario -->
            </ng-template>
          </p-table>
        </div>
        <div *ngIf="isDownloading" class="loading-overlay" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(255,255,255,0.9); display: flex; justify-content: center; align-items: center; z-index: 1000;">
          <ng-lottie [options]="options" width="300px" height="300px"></ng-lottie>
        </div>
    </p-tabPanel>

    <!-- Tab Mappa -->
    <p-tabPanel header="Mappa" leftIcon="pi pi-map-marker">
      <div class="map-container">
        <div #map class="map-view"></div>
      </div>
    </p-tabPanel>
  </p-tabView>
  </div>

  <!-- Toast per notifiche -->
  <p-toast position="top-right"></p-toast>
  <p-tieredMenu #menuAzioniTiered [popup]="true" [model]="menuAzioniItems"></p-tieredMenu>

  <!-- Componente per la creazione di una nuova scheda -->
  <app-nuova-scheda (schedaCreata)="onSchedaCreata($event)" [isEnteEsecutore]="isEnteEsecutore"></app-nuova-scheda>

  <!-- Aggiungi qui il componente per la mappa in modale -->
  <app-mappa-scheda
    [(visible)]="showMappaScheda"
    [titolo]="mappaSchedaTitolo"
    [datiGeoJSON]="selectedFeatureGeoJSON"
    [scheda]="schedaSelezionata">
  </app-mappa-scheda>

  <!-- Modale di conferma cancellazione -->
  <p-dialog
  [(visible)]="showConfermaCancellazione"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [style]="{width: '450px'}"
  styleClass="p-fluid conferma-eliminazione-dialog"
  [showHeader]="false"
  (onHide)="showConfermaCancellazione = false">
  <div class="dialog-header">
    <div class="header-content">
      <i class="pi pi-trash header-icon"></i>
      <h2>Conferma Eliminazione</h2>
    </div>
    <button
      pButton
      pRipple
      icon="pi pi-times"
      class="p-button-rounded p-button-text close-btn"
      (click)="showConfermaCancellazione = false">
    </button>
  </div>
  <div class="dialog-content">
    <div class="confirmation-content text-center">
      <div class="flex justify-content-center mb-3">
        <i class="pi pi-exclamation-triangle" style="font-size: 2rem; color: #f44336;"></i>
      </div>
      <span class="confirmation-message text-center" style="display: block;">
        Sei sicuro di voler eliminare la scheda {{ schedaDaEliminare?.codice }}?
        <br>
        Questa azione non può essere annullata.
      </span>
    </div>
  </div>

  <div class="dialog-footer">
    <button
      pButton
      pRipple
      label="Annulla"
      icon="pi pi-times"
      class="p-button-outlined p-button-secondary"
      (click)="showConfermaCancellazione = false">
    </button>
    <button
      pButton
      pRipple
      label="Elimina"
      icon="pi pi-trash"
      class="p-button-danger"
      (click)="confermaEliminazione()">
    </button>
    </div>


  </p-dialog>

  <!-- Modale di conferma approvazione -->
  <p-dialog
    [(visible)]="showConfermaApprovazione"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closeOnEscape]="true"
    [dismissableMask]="true"
    [style]="{width: '600px'}"
    styleClass="p-fluid conferma-eliminazione-dialog"
    [showHeader]="false"
    (onHide)="showConfermaApprovazione = false">
    <div class="conferma-approvazione-dialog-header">
      <div class="header-content">
        <i class="pi pi-check-circle header-icon"></i>
        <h2>Approvazione Scheda</h2>
        <div class="code-badge" style="background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem;">
          <span class="code-value" style="font-weight: bold; color: #3a6e75;">{{ schedaDaApprovare?.codice }}</span>
        </div>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        (click)="showConfermaApprovazione = false">
      </button>
    </div>
    <div class="dialog-content">
      <div class="confirmation-content text-center">
       <!--  <div class="flex justify-content-center mb-3">
          <i class="pi pi-check-circle" style="font-size: 2rem; color: #4CAF50;"></i>
        </div> -->
        <span class="confirmation-message text-center" style="display: block;">
          Sei sicuro di voler approvare la scheda <strong>{{ schedaDaApprovare?.codice }}</strong>?
          <br>
          Questa azione non può essere annullata.
        </span>
      </div>
    </div>

    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        (click)="showConfermaApprovazione = false">
      </button>
      <button
        pButton
        pRipple
        label="Approva"
        icon="pi pi-check"
        class="p-button-success"
        (click)="confermaApprovazione()">
      </button>
    </div>
  </p-dialog>

  <!-- Modale del carosello -->
  <app-carosello-immagini
    *ngIf="displayCarosello"
    [visible]="displayCarosello"
    [codiceScheda]="codiceSchedaCarosello"
    (visibleChange)="displayCarosello = $event"
    [isEnteEsecutore]="isEnteEsecutore"
    >
  </app-carosello-immagini>

  <app-carica-immagini></app-carica-immagini>

  <app-modifica-scheda
    (schedaModificata)="onSchedaModificata($event)"
    (ricaricaSchede)="caricaSchede()">
  </app-modifica-scheda>

  <app-carica-allegato
    [(visible)]="showCaricaAllegato"
    [scheda]="schedaCaricaAllegato"
    [tipoAllegato]="tipoAllegatoCarica"
    (onHide)="showCaricaAllegato = false">
  </app-carica-allegato>

  <app-carica-geojson
    [(visible)]="showCaricaGeoJSON"
    [scheda]="schedaCaricaGeoJSON"
    (onHide)="showCaricaGeoJSON = false">
  </app-carica-geojson>
</div>
